export let ToolbarEnum;

(function (ToolbarEnum) {
  ToolbarEnum[ToolbarEnum["DATA"] = 0] = "DATA";
  ToolbarEnum[ToolbarEnum["THEME"] = 1] = "THEME";
  ToolbarEnum[ToolbarEnum["RESIZE"] = 2] = "RESIZE";
  ToolbarEnum[ToolbarEnum["CANVAS"] = 3] = "CANVAS";
  ToolbarEnum[ToolbarEnum["AI"] = 4] = "AI";
})(ToolbarEnum || (ToolbarEnum = {}));